import React, { useEffect, useRef, useState } from "react";
import { useSelector, connect, useDispatch } from "react-redux";
import DisplayBox from "../../hoc/DisplayBox/DisplayBox";
import {ACTIVITY_LOG_SEARCH_TYPE, ACTIVITY_LOG_SELECT_MAP, ACTIVITY_LOG_SELECT_MAP_REVERSED, ACTIVITY_LOG_USER_EVENT_MAP, ACTIVITY_LOG_USER_EVENT_MAP_REVERSED, AGENT_ACTIVITY_SEARCH, AGENT_ACTIVITY_SEARCH_MESSAGE, PAGESIZE_ACTIVITY_LOG, SESSION_TIER1USER, USER_ACTIVITY_DISABLE_FLAG } from "../../shared/Constants";
import Button from "../../UI/Button/Button";
import  classes  from "./ActivityLog.css";
import Message from "../../components/Message/Message";
import ActivityLogResults from "./ActivityLogResults";
import {setSearchState} from '../../store/actions/agentActivity';
import * as actions from '../../store/actions/index';
import EventBlock from "./EventBlock";
import UUIDBlock from "./UUIDBlock";
import StatusStartEndDate from "./StatusStartEndDate";
import UserNameBlock from "./UserNameBlock";
import { isStartDateGreaterThenEndDate } from "../../shared/utility";
import UserSearchBlock from "./UserSearchBlock";

const ActivityLogForm = (props) => {

    const dispatch = useDispatch();

    const errorMsg = useSelector(state => state.agentActivity.error);
    const isActivitySearchedState = useSelector(state => state.agentActivity.isActivitySearched);
    const searchState = useSelector(state => state.agentActivity.activityLogSearchState)
    const persistedSearchRequest = useSelector(state => actions.getPersistedSearchRequest(state, ACTIVITY_LOG_SEARCH_TYPE))

    const clearStatusStartEnd = useRef(null)
    const clearUsername = useRef(null)
    const clearUuid = useRef(null)
    const clearEvent = useRef(null)
    const clearUser = useRef(null)
    const restoredFromPersistedSearch = useRef(false)

    const [eventList, setEventList] = useState([])
    const [agentIdDisabled, setAgentIdDisabled] = useState(false)

    useEffect(() => {
        if (persistedSearchRequest) {
            restorePersistedSearch(persistedSearchRequest);
        } else {
            props.isActivitySearched(false);
            clearSearch();
        }
        window.scrollTo(0, 0);
    }, [])

    const [agentId, setAgentId] = useState('')
    const [username, setUsername] = useState('')
    const [uuid, setUuid] = useState('')
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] =useState('')
    const [event, setEvent] = useState('Select One')
    const [eventStatus, setEventStatus] = useState('Select One')
    const [eventType, setEventType] = useState(props.user?.userType !== SESSION_TIER1USER ? 'Select One' : 'USER')

    const [statusFormValid, setStatusFormValid] = useState(true)
    const [userNameFormValid, setUserNameFormValid] = useState(true)
    const [uuidValid, setUuidValid] = useState(true)
    const [userSearchValid, setUserSearchValid] = useState(true)
    const [activityResultSearch, setActivityResultSearch] = useState({})

    const [firstName, setFirstName] = useState({value:'', touched:false})
    const [lastName, setLastName] = useState({value:'', touched:false})
    const [dob, setDOB] = useState({value:'', touched:false})

    const formHeader = AGENT_ACTIVITY_SEARCH;
 
    const errorHandler = (error) => {
        props.setError(error);
    }

    useEffect(() => {
        // A restored search already carries its own event type, so it must not be reset here.
        if (restoredFromPersistedSearch.current) {
            return;
        }
        setEventType(props.user?.userType !== SESSION_TIER1USER ? 'Select One' : 'USER')
    }, [props.user?.userType])

    const isAllEventTypeSelected = eventType === 'ALL'

    const message = isAllEventTypeSelected ? "UUID or Username is mandatory to search" : AGENT_ACTIVITY_SEARCH_MESSAGE;

    const isUserOrAllEventTypeSelected = eventType === 'USER' || isAllEventTypeSelected
    const hasUuidOrUsernameProvidedForAllEventType = uuid.trim() !== '' || username.trim() !== ''

    const activityLogSearchHandler = (eventR) => {

        eventR.preventDefault();

        let formData = {};

        if(isStartDateGreaterThenEndDate(startDate, endDate)){
            props.setError({"message": "Start Date cannot be greater than End Date."})
            return
        }

        if(isUserOrAllEventTypeSelected){
            formData['agentId'] = ''
        }
        else {
            formData['agentId'] = agentId
        }

        if(isAllEventTypeSelected && !hasUuidOrUsernameProvidedForAllEventType){
            props.setError({"message": "UUID or User Name is required when Event Type is ALL selected"})
            return
        }
        
        formData['eventType'] = eventType === 'Select One' ? "AGENT": eventType
        formData['uuid'] = uuid.trim()
        formData['event'] = ACTIVITY_LOG_SELECT_MAP[event]?ACTIVITY_LOG_SELECT_MAP[event].value:ACTIVITY_LOG_USER_EVENT_MAP[event].value
        formData['startDate'] = startDate
        formData['endDate'] = endDate
        formData['username'] = username.trim()
        formData["page"] = 1
        
        formData['firstName'] = firstName.touched?firstName.value:''
        formData['lastName'] = lastName.touched?lastName.value:''
        formData['dob'] = dob.touched?dob.value:''
        
        formData["pageSize"] = PAGESIZE_ACTIVITY_LOG;
        if(eventStatus === 'Select One')formData['eventStatus'] = ''
        else formData['eventStatus'] = eventStatus

        dispatch(setSearchState(formData))
        props.setPersistedSearchRequest(ACTIVITY_LOG_SEARCH_TYPE, formData)
        props.activitySearch(formData)
        props.isActivitySearched(true);
        dispatch(actions.activitySearchSetPageNumber(1))
        setActivityResultSearch(formData)
    }

    const setCancelEventList = () => {
        let sfullEvents = Object.keys(ACTIVITY_LOG_SELECT_MAP).map(
            (activity) => ({
                "disabled": false,
                "value": activity,
                "displayValue": activity
            })
        )
        let temp = Object.values(ACTIVITY_LOG_USER_EVENT_MAP).filter(val => val.name !== 'Select One')
        let tempEvents = temp.map(
            activity => ({
                "disabled": activity.disabled,
                "value": activity.name,
                "displayValue": activity.name
            })
        )
        sfullEvents = sfullEvents.concat(tempEvents)
        setEventList(sfullEvents)
    }

    const getEventName = (eventValue) => {
        if (!eventValue) {
            return 'Select One';
        }
        const mappedEvent = ACTIVITY_LOG_SELECT_MAP_REVERSED[eventValue] || ACTIVITY_LOG_USER_EVENT_MAP_REVERSED[eventValue];
        return mappedEvent ? mappedEvent.name : 'Select One';
    }

    const restorePersistedSearch = (request) => {
        restoredFromPersistedSearch.current = true
        setAgentId(request.agentId || '')
        setStartDate(request.startDate || '')
        setEndDate(request.endDate || '')
        setEventStatus(request.eventStatus || 'Select One')
        setEventType(request.eventType || 'Select One')
        setEvent(getEventName(request.event))
        setUsername(request.username || '')
        setUuid(request.uuid || '')
        setFirstName({value: request.firstName || '', touched: !!request.firstName})
        setLastName({value: request.lastName || '', touched: !!request.lastName})
        setDOB({value: request.dob || '', touched: !!request.dob})

        setCancelEventList()
        setActivityResultSearch(request)

        dispatch(setSearchState(request))
        dispatch(actions.activitySearchSetPageNumber(1))
        props.activitySearch(request)
        props.isActivitySearched(true)
    }

    const clearSearch = () => {
        restoredFromPersistedSearch.current = false
        setAgentId('')
        setStartDate('')
        setEndDate('')
        setEventStatus('Select One')
        setEventType(props.user?.userType !== SESSION_TIER1USER ? 'Select One' : 'USER')
        setEvent('Select One')
        setUsername('')
        setUuid('')
        setFirstName({value:'', touched: false})
        setLastName({value:'', touched: false})
        setDOB({value:'', touched: false})

        dispatch(setSearchState(null))
        props.clearPersistedSearchRequest(ACTIVITY_LOG_SEARCH_TYPE)
        setCancelEventList()

        if(clearStatusStartEnd.current)clearStatusStartEnd.current()
        if(clearEvent.current)clearEvent.current()
        if(clearUsername.current)clearUsername.current()
        if(clearUuid.current)clearUuid.current()
        if(clearUser.current)clearUser.current()

        setAgentIdDisabled(false)

        dispatch(actions.setError(null))
    }

    const checkCommonValidity = () => {
        return (userNameFormValid && uuidValid && statusFormValid)
    }

    const checkUserAndBig3Status = () => {
        if(event === 'Authenticate'){
            return checkCommonValidity()
        }
        return checkCommonValidity()
    }

    const isSearchButtonDisabled = () => {
        if(USER_ACTIVITY_DISABLE_FLAG) return !checkCommonValidity()

        if(eventType === "USER") return !checkUserAndBig3Status()

        if(isAllEventTypeSelected) return !checkCommonValidity() || !hasUuidOrUsernameProvidedForAllEventType

        return !(checkCommonValidity() && eventType !== 'Select One')
    }
    

    const createForm = () => {
        
        return (
            <form onSubmit={activityLogSearchHandler}>
                <EventBlock 
                    eventValue = {event} 
                    eventTypeValue = {eventType}
                    eventList = {eventList}
                    userType={props.user?.userType}
                    setEvent = {setEvent} 
                    setEventType = {setEventType}
                    setEventStatus = {setEventStatus}
                    errorHandler = {errorHandler}
                    setEventList = {setEventList}
                    clearSearch = {clearEvent}
                    searchState = {searchState}
                    setAgentIdDisabled={setAgentIdDisabled}
                    agentIdDisabled = {agentIdDisabled}
                    flagUserActivity = {USER_ACTIVITY_DISABLE_FLAG}
                />
                {!isUserOrAllEventTypeSelected && <UUIDBlock  
                    agentIdValue = {agentId}
                    uuidValue = {uuid}
                    setAgentId = {setAgentId}
                    setUuid = {setUuid}
                    errorHandler = {errorHandler}
                    formIsValid = {uuidValid}
                    setFormIsValid={setUuidValid}
                    clearSearch = {clearUuid}
                    searchState = {searchState}
                    agentIdDisabled = {agentIdDisabled}
                />}
                <StatusStartEndDate
                    eventStatusValue = {eventStatus}
                    startDateValue = {startDate}
                    endDateValue = {endDate} 
                    setEventStatus = {setEventStatus}
                    setStartDate = {setStartDate}
                    setEndDate = {setEndDate}
                    clearSearch = {clearStatusStartEnd}
                    errorHandler = {errorHandler} 
                    formIsValid = {statusFormValid}
                    setFormIsValid={setStatusFormValid}
                    searchState = {searchState}
                    event = {event}
                    eventType = {eventType}
                />
                <UserNameBlock
                    userNameValue = {username}
                    setUsername = {setUsername}
                    errorHandler = {errorHandler}
                    formIsValid = {userNameFormValid}
                    setFormIsValid={setUserNameFormValid}
                    clearSearch = {clearUsername}
                    uuidValue = {uuid}
                    setUuid = {setUuid}
                    setUUIDFormIsValid={setUuidValid}
                    eventType = {eventType}
                    searchState = {searchState}
                />
                {
                    eventType === 'USER' &&  <UserSearchBlock
                        firstName = {firstName}
                        lastName = {lastName}
                        dob = {dob}
                        setFirstName = {setFirstName}
                        setLastName = {setLastName}
                        setDOB = {setDOB}
                        clearSearch = {clearUser}
                        eventSelected = {event}
                        errorHandler = {errorHandler}
                        formIsValid = {userSearchValid}
                        setFormIsValid = {setUserSearchValid}
                    />
                }
                <div style={{display:'flex', justifyContent:'center'}}>
                    <Button id="cancelSearch" btnType="Cancel" clicked={clearSearch} attr={{type: "button"}}>
                        Clear All
                    </Button>
                    <Button id="activityLogSearch" btnType="Search" disabled={isSearchButtonDisabled()}>Search</Button>
                </div>
            </form>
        )

    }

    return(
        <>
        {
            !isActivitySearchedState ?
            <DisplayBox>
                <div className={classes.SearchWindow}>
                    <h2 className={classes.FormTitle}>{formHeader}</h2>
                    <p className={classes.Message}>{message}</p>
                    <Message msgType="Error" info={errorMsg} />
                    {createForm()}
                </div>
            </DisplayBox>
            :<ActivityLogResults
                eventList = {eventList}
                activityResultSearch = {activityResultSearch}
                setActivityResultSearch = {setActivityResultSearch}
                clearSearch = {clearSearch}
                eventType = {eventType}
            />
        }
        </>
    );
}

export const mapStateToProps = state => {
    return {
        user: state.usr.user
    }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        isActivitySearched: (searched) => dispatch(actions.isActivitySearched(searched)),
        setError: (error) => dispatch(actions.setError(error)),
        activitySearch: (formInputElements) => dispatch(actions.activitySearch(formInputElements)),
        setPersistedSearchRequest: (searchType, request) => dispatch(actions.setPersistedSearchRequest(searchType, request)),
        clearPersistedSearchRequest: (searchType) => dispatch(actions.clearPersistedSearchRequest(searchType))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLogForm);